export default {
  home: "/",
};
